var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArmedForcesCharities = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Army-Badge-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Army Badge 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.21 7.68a1.49 1.49 0 0 0 -1.54 0.07l-5.39 3.6a0.52 0.52 0 0 1 -0.56 0l-5.39 -3.6A1.5 1.5 0 0 0 4 9v2.35a0.5 0.5 0 0 0 0.24 0.43l7.47 4.54a0.47 0.47 0 0 0 0.51 0l7.54 -4.54a0.5 0.5 0 0 0 0.24 -0.43V9a1.49 1.49 0 0 0 -0.79 -1.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.74 14.43a0.47 0.47 0 0 0 -0.5 0l-6.17 3.75a1.88 1.88 0 0 1 -1.07 0.32 2 2 0 0 1 -1.12 -0.34l-6.12 -3.72a0.47 0.47 0 0 0 -0.5 0 0.48 0.48 0 0 0 -0.26 0.43v3.31a1.47 1.47 0 0 0 0.67 1.24l6.5 4.34a1.5 1.5 0 0 0 1.66 0l6.5 -4.34a1.47 1.47 0 0 0 0.67 -1.25v-3.31a0.49 0.49 0 0 0 -0.26 -0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65 4.82a0.51 0.51 0 0 1 0.1 0.56l-0.82 1.89a0.53 0.53 0 0 0 0.75 0.66l2.07 -1.17a0.5 0.5 0 0 1 0.5 0l2.07 1.17a0.53 0.53 0 0 0 0.75 -0.66l-0.82 -1.89a0.51 0.51 0 0 1 0.1 -0.56l1.49 -1.46a0.49 0.49 0 0 0 -0.34 -0.86h-1.68a0.51 0.51 0 0 1 -0.46 -0.29L12.47 0.29a0.52 0.52 0 0 0 -0.94 0l-0.9 1.92a0.49 0.49 0 0 1 -0.45 0.29H8.5a0.49 0.49 0 0 0 -0.34 0.86Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArmedForcesCharities);
export default ForwardRef;